import React from "react";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { CONTACT, WHATSAPP_URL, TEL_URL, MAIL_URL } from "../../lib/contact";
import logoMark from "../../assets/images/logo-mark.png";

const SERVICES_LIST = [
  "Avalúos Comerciales",
  "Avalúos Inmobiliarios",
  "Justipreciación de Rentas",
  "Peritajes Técnicos",
  "Dictámenes Técnicos",
  "Dirección Responsable de Obra",
  "Regularización de Inmuebles",
  "Licencias y Trámites",
  "Supervisión de Obra",
  "Consultoría Técnica",
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-brand-dark text-white pt-20 pb-8 overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 bg-blueprint-dark bg-grid-40 opacity-60" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3">
            <img
              src={logoMark}
              alt="Rodríguez Valuación y DRO"
              className="h-20 w-auto object-contain bg-white/95 rounded-sm p-2"
              loading="lazy"
              width="88"
              height="88"
            />
            <div className="leading-tight">
              <div className="font-playfair text-xl text-brand-gold">Rodríguez · Valuación</div>
              <div className="font-mont text-[10px] uppercase tracking-[0.22em] text-white/50">
                & DRO · Puebla
              </div>
            </div>
          </div>
          <p className="mt-5 font-inter text-sm text-white/65 leading-relaxed max-w-xs">
            Valuación profesional con más de 40 años de experiencia en Puebla, México.
            Avalúos, peritajes y DRO con respaldo técnico, legal y profesional.
          </p>

          <div className="mt-6 flex items-center gap-2">
            {/* Facebook/LinkedIn quitados: aún no existen esos perfiles.
                Cuando el cliente tenga redes reales, agrégalas aquí con su URL real. */}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="flex h-9 w-9 items-center justify-center rounded-sm border border-white/10 hover:border-brand-gold hover:text-brand-gold transition-colors"
            >
              <MessageCircle size={15} />
            </a>
          </div>
        </div>

        {/* Servicios */}
        <div>
          <div className="font-mont text-[10px] uppercase tracking-[0.28em] text-brand-gold">
            Servicios
          </div>
          <ul className="mt-5 grid grid-cols-1 gap-2.5 font-inter text-sm text-white/70">
            {SERVICES_LIST.map(s => (
              <li key={s}>
                <a href="#servicios" className="hover:text-brand-gold transition-colors">
                  {s}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contacto */}
        <div>
          <div className="font-mont text-[10px] uppercase tracking-[0.28em] text-brand-gold">
            Contacto
          </div>
          <ul className="mt-5 space-y-4 font-inter text-sm text-white/75">
            <li className="flex items-start gap-3">
              <Phone size={15} className="text-brand-gold mt-0.5" />
              <a href={TEL_URL} className="hover:text-brand-gold transition-colors">
                {CONTACT.phoneIntl}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle size={15} className="text-brand-gold mt-0.5" />
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors">
                WhatsApp: {CONTACT.phoneIntl}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={15} className="text-brand-gold mt-0.5" />
              <a href={MAIL_URL} className="hover:text-brand-gold transition-colors break-all">
                {CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={15} className="text-brand-gold mt-0.5" />
              <span>{CONTACT.addressFull}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 mt-16">
        <div className="gold-divider opacity-60" />
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3 font-inter text-xs text-white/55 text-center md:text-left">
          <p>
            © {new Date().getFullYear()} Creado por{" "}
            <a
              href="https://www.grupoempresarialandar.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-andar-link"
              className="text-brand-gold hover:underline"
            >
              Grupo Empresarial Andar
            </a>
            . Todos los derechos reservados.
          </p>
          <p className="font-mont uppercase tracking-[0.22em] text-[10px]">
            Puebla · México
          </p>
        </div>
      </div>
    </footer>
  );
}
